import { MessageBarType } from "office-ui-fabric-react";
import React, { Component } from 'react';
import { connect } from "react-redux";
import School from "../models/School";
import Actions from "../redux/Actions";
import { IRootState } from "../store";
import DispatchProps from "../utils/DispatchProps";
import ApiService from "./ApiService";
import SchoolCell from "./SchoolCell";
import Table, { TableColumn } from "./Table";
import TableCell from "./TableCell";
import { TableRowProps } from "./TableRow";

export interface SchoolInfoHeaderProps {
    schoolCode: string;
    tenantId: string;
    apiService: ApiService;
}

export interface SchoolInfoHeaderState {
    school: School | undefined | null;
}

const columns: TableColumn[] = [
    {
        title: "School",
        propertyPath: "schoolName",
        flex: 4,
    },
    {
        title: "Tenant",
        propertyPath: "tenantName",
        flex: 4,
    }
];

class SchoolInfoHeader extends Component<SchoolInfoHeaderProps & DispatchProps, SchoolInfoHeaderState> {

    constructor(props: SchoolInfoHeaderProps & DispatchProps) {
        super(props);

        this.state = {
            school: undefined
        };
    }

    public async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode) {
            await this.load();
        }
    }

    async componentDidUpdate(prevProps: Readonly<SchoolInfoHeaderProps & DispatchProps>, prevState: Readonly<SchoolInfoHeaderState>, snapshot?: any): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.load();
        }
    }

    private async load() {
        try {
            const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId, this.props.schoolCode);
            this.setState({
                school: school
            });
        }
        catch (e) {
            this.setState({ school: null });
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Error loading school information`, MessageBarType.error));
        }
    }

    private columnRowProps = (row: School): TableRowProps => {
        return {
            enableRowLink: false
        };
    };

    private cellForColumn = (school: School, column: TableColumn, columnIndex: number): JSX.Element | undefined => {
        switch (column.propertyPath) {
            case "schoolName":
                return <SchoolCell key={`${columnIndex}-${column.propertyPath}`} schoolKey={school} school={school} enableLink={false} flex={column.flex} />

            case "tenantName":
                return <TableCell key={`${columnIndex}-${column.propertyPath}`} flex={column.flex}>
                    <span>{school.tenantName}</span>
                    <span className={"cdb-table__extra-detail"}>{school.tenantId}</span>
                </TableCell>;
        }
    }

    public render() {
        return (
            <Table
                items={this.state.school != undefined ? [this.state.school] : []}
                columns={columns}
                rowPropsForItem={this.columnRowProps}
                cellForColumn={this.cellForColumn}
                loading={this.state.school === undefined}>
            </Table>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { schoolCode: string, tenantId: string }): SchoolInfoHeaderProps => {
        return {
            schoolCode: ownProps.schoolCode,
            tenantId: ownProps.tenantId,
            apiService: state.auth.apiService,
        };
    }
)(SchoolInfoHeader);